import * as React from 'react';
import { AdminDashboardPageLayout } from '../../containers/AdminDashboardPageLayout';
import { BlogEditor } from '../../containers/blogs/BlogEditor';

export const AdminAccountBlogEditorPage: React.FC = () => {
	return (
		<AdminDashboardPageLayout>
			<BlogEditor />
		</AdminDashboardPageLayout>
	);
};
